module.exports = __webpack_public_path__ + "img/img_38@2x.7a9abce3.png";